export default {
  en: {
    folders: 'Folders',
    files: 'Files',
    name: 'Name',
    owner: 'Owner',
    created_at: 'Date created',
    size: 'File size',
  },
};
